import { http } from './config'

export default {

  getAllProductGroups: () => {
    return http.get('product_groups')
  },

  getFilteredProductGroups: (params) => {
    return http.get('product_groups', {params})
  },

  getProductGroupById: (productGroupId) => {
    return http.get('product_groups/' + productGroupId)
  },

  createProductGroup: (productGroupParams) => {
    return http.post('product_groups', {
      name: productGroupParams.name
    }
  )},

  updateProductGroup: (productGroupParams) => {
    return http.put('product_groups/' + productGroupParams.productGroupId, {
      name: productGroupParams.name
    }
  )},

  deleteProductGroup: (productGroupId) => {
    return http.delete('product_groups/' + productGroupId)
  },

  exportProductGroupReport: () => {
    return http.get(`product_groups/export_product_groups_report`)
  },

}
